module.exports = __webpack_public_path__ + "media/images/defaults/questionnaire_image/thumb-ed49a61fb211fcc0eacbf9fdf06ea5f0.png";